const LOCAL_BACKEND_URL = "http://localhost:5000";

const PRODUCTION_API_URL =
  process.env.REACT_APP_API_URL ||
  "https://homefoods-backend-production.up.railway.app/api";

const PRODUCTION_BACKEND_URL =
  PRODUCTION_API_URL.replace(/\/api\/?$/, "");

// Detect whether React is running locally
const isLocal =
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1";

const BACKEND_URL = isLocal
  ? LOCAL_BACKEND_URL
  : PRODUCTION_BACKEND_URL;


export const getImageUrl = (image) => {

  if (!image) {
    return "";
  }

  const imagePath = String(image).trim();

  if (!imagePath) {
    return "";
  }

  let finalUrl = "";

  // Already a complete URL
  if (
    imagePath.startsWith("http://") ||
    imagePath.startsWith("https://")
  ) {

    if (imagePath.includes("localhost:5000")) {

      finalUrl = imagePath.replace(
        /^https?:\/\/localhost:5000/,
        BACKEND_URL
      );

    } else {

      finalUrl = imagePath;

    }

    console.log("IMAGE INPUT:", image);
    console.log("IMAGE URL:", finalUrl);

    return finalUrl;
  }

  // /uploads/filename
  if (imagePath.startsWith("/uploads/")) {

    finalUrl = `${BACKEND_URL}${imagePath}`;

    console.log("IMAGE INPUT:", image);
    console.log("IMAGE URL:", finalUrl);

    return finalUrl;
  }

  // uploads/filename
  if (imagePath.startsWith("uploads/")) {

    finalUrl = `${BACKEND_URL}/${imagePath}`;

    console.log("IMAGE INPUT:", image);
    console.log("IMAGE URL:", finalUrl);

    return finalUrl;
  }

  // Bare filename
  if (
    !imagePath.startsWith("/") &&
    !imagePath.includes("/")
  ) {

    finalUrl = `${BACKEND_URL}/uploads/${imagePath}`;

    console.log("IMAGE INPUT:", image);
    console.log("IMAGE URL:", finalUrl);

    return finalUrl;
  }

  // Other relative paths
  if (imagePath.startsWith("/")) {

    finalUrl = `${BACKEND_URL}${imagePath}`;

    console.log("IMAGE INPUT:", image);
    console.log("IMAGE URL:", finalUrl);

    return finalUrl;
  }

  console.log("IMAGE INPUT:", image);
  console.log("IMAGE URL:", imagePath);

  return imagePath;
};


export default getImageUrl;